var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { COLOR } from "../../../theme/constants";
import styled from "styled-components";
import { Col, Container } from "reactstrap";
import { space } from "styled-system";
export var LogosArvalContainer = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n\n  ", "\n"], ["\n  background-color: ", ";\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n\n  ", "\n"])), COLOR.white, space);
export var LogosArvalCol = styled(Col)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
export var LogosArvalImg = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 165px;\n"], ["\n  max-width: 165px;\n"])));
export var LogosArvalText = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 0.6875rem;\n  letter-spacing: 0.07px;\n  color: ", ";\n  margin-top: 10px;\n"], ["\n  font-size: 0.6875rem;\n  letter-spacing: 0.07px;\n  color: ", ";\n  margin-top: 10px;\n"])), COLOR.brandGreen);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;